import React from 'react';
import { Container, Row, Col, Card, CardBody, Button } from 'reactstrap';
import { Link } from 'react-router-dom';
import BreadCrumb from '../../Components/Common/BreadCrumb';

const DashboardCrm = () => {
    document.title = "CRM Expert Dashboard | Leads & Contacts";
    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title="CRM" pageTitle="Dashboard" />
                    <Row className="justify-content-center mt-4">
                        <Col lg={6} xl={5} className="mb-4">
                            <Card className="shadow-lg border-0 rounded-4">
                                <CardBody className="text-center p-5">
                                    <h4 className="fw-semibold mb-3">CRM Leads</h4>
                                    <p className="text-muted mb-4">Manage and convert your leads from one central place.</p>
                                    <Button tag={Link} to="/apps-crm-leads" color="primary" className="px-5">Go to Leads</Button>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col lg={6} xl={5} className="mb-4">
                            <Card className="shadow-lg border-0 rounded-4">
                                <CardBody className="text-center p-5">
                                    <h4 className="fw-semibold mb-3">CRM Contacts</h4>
                                    <p className="text-muted mb-4">View and manage your CRM contacts quickly and easily.</p>
                                    <Button tag={Link} to="/apps-crm-contacts" color="secondary" className="px-5">Go to Contacts</Button>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default DashboardCrm;
